import { z } from 'zod';

export const FEATURE_FLAGS = {
  HALL_OF_FAME: 'hall_of_fame',
  SOCIAL_SHAREABLE_IMAGE: 'social_shareable_image',
} as const;

type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export const featureFlagSchema = z.object<Record<FeatureFlag, z.ZodBoolean>>({
  [FEATURE_FLAGS.HALL_OF_FAME]: z.boolean(),
  [FEATURE_FLAGS.SOCIAL_SHAREABLE_IMAGE]: z.boolean(),
});

export type FeatureFlags = z.infer<typeof featureFlagSchema>;
